<template>
  <div
    v-if="isNotPipRootRoute"
    class="hidden pip:flex justify-between p-2 sticky top-0 z-50 md:relative md:p-0 md:m-0 bg-pink-medium md:bg-transparent"
  >
    <Link :to="pipData.backLink" class="flex space-x-1 items-center">
      <CoreIcon icon="arrow" size="2xs" />
      <span class="font-serif font-bold text-sm cursor-pointer hover:underline">
        {{ pipData.label }}
      </span>
    </Link>
  </div>
</template>

<script lang="ts" setup>
import { onMounted, ref, watch } from 'vue'
import { useRoute } from 'vue-router'

const isNotPipRootRoute = ref(false)
const pipData = ref({
  label: '',
  backLink: '',
})
onMounted(() => {
  pipData.value.label = document.body.dataset['pip-label'] ?? ''
  pipData.value.backLink = document.body.dataset['pip-back-link'] ?? ''

  // note: to be sure, in case we failed on the initial page load
  setTimeout(() => {
    pipData.value.label = document.body.dataset['pip-label'] ?? ''
    pipData.value.backLink = document.body.dataset['pip-back-link'] ?? ''
  }, 1000)
})

const route = useRoute()
watch(
  () => route.path,
  p => {
    if (!document.body.dataset['pip-root-route']) return

    isNotPipRootRoute.value = !p.includes(
      document.body.dataset['pip-root-route'],
    )
  },
  { immediate: true },
)
</script>
